import React from 'react';
import PropTypes from 'prop-types';
import { createIntl, createIntlCache, RawIntlProvider } from 'react-intl';

const intlCache = createIntlCache();

const I18NProvider = (props) => {
  const { messages, language, children } = props;

  if (language) {
    const intl = createIntl({ locale: language, messages }, intlCache);
    return <RawIntlProvider value={intl}>{children}</RawIntlProvider>;
  }

  return children;
};

I18NProvider.propTypes = {
  children: PropTypes.node.isRequired,

  language: PropTypes.string,
  messages: PropTypes.object,
};

I18NProvider.defaultProps = {
  language: undefined,
  messages: {},
};

export default I18NProvider;
